var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinciple3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 108,
    viewBox: "0 0 70 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M66.6983 45.8801L69.3103 38.8391C69.8781 37.3627 68.7425 35.7728 67.1526 35.7728H17.6384C9.68883 35.7728 3.10208 41.6782 2.30713 49.6277L0.262964 68.4795C0.035835 70.2965 1.28505 72 3.10208 72.4542C5.14625 72.9085 7.8718 73.2492 10.5974 73.5899L12.3008 103.571C12.4144 106.069 14.5721 108 17.0705 108H31.4932C33.9917 108 36.0358 106.069 36.263 103.571L38.7614 52.1261C38.7614 49.5142 40.9191 47.47 43.4175 47.47H64.427C65.5627 47.3564 66.4712 46.7886 66.6983 45.8801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.4525 31.571C33.1706 31.571 40.238 24.5036 40.238 15.7855C40.238 7.0674 33.1706 0 24.4525 0C15.7344 0 8.66699 7.0674 8.66699 15.7855C8.66699 24.5036 15.7344 31.571 24.4525 31.571Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69.7646 67.9115C69.7646 61.3247 64.4271 55.9872 57.8403 55.9872C51.2536 55.9872 45.916 61.3247 45.916 67.9115C45.916 73.249 49.5501 77.7916 54.4334 79.2679V88.6938H49.8908C48.4144 88.6938 47.2788 89.8295 47.2788 91.3058C47.2788 92.7821 48.4144 93.9178 49.8908 93.9178H54.4334V97.2112H49.8908C48.4144 97.2112 47.2788 98.3468 47.2788 99.8231C47.2788 101.299 48.4144 102.435 49.8908 102.435H54.4334V103.911C54.4334 105.729 55.9097 107.205 57.7267 107.205C59.5438 107.205 61.0201 105.729 61.0201 103.911V79.2679C66.1305 77.7916 69.7646 73.3626 69.7646 67.9115ZM57.8403 73.1355C55.0012 73.1355 52.6163 70.7506 52.6163 67.9115C52.6163 65.0724 55.0012 62.6875 57.8403 62.6875C60.6794 62.6875 63.0643 65.0724 63.0643 67.9115C63.0643 70.7506 60.793 73.1355 57.8403 73.1355Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciple3);
export default __webpack_public_path__ + "static/media/principle-3.9927b99fd92421419e8dfc9612852178.svg";
export { ForwardRef as ReactComponent };